import type { LanguageKey } from "@packages/core/language/language.ts";
import type { Runtime } from "@squide/firefly";
import { getI18nextPlugin, type i18nextPlugin } from "@squide/i18next";
import type { ResourceLanguage } from "i18next";
import { createI18nextInstance } from "./createI18nextInstance.ts";

export function registerLazyI18nextInstance(runtime: Runtime, key: string, loaders: Record<LanguageKey, () => Promise<ResourceLanguage>>) {
    const plugin = getI18nextPlugin(runtime) as i18nextPlugin<LanguageKey>;

    try {
        return plugin.getInstance(key);
    } catch {}

    const instance = createI18nextInstance(plugin.currentLanguage, { resources: {} });

    plugin.registerInstance(key, instance, {
        loadResources: language => loaders[language]()
    });

    return instance;
}
